import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { UserService } from '@ebf/core/user/services/user.service';

export const isGuestGuard: CanActivateFn = () => {
  const userService: UserService = inject(UserService);
  const router: Router = inject(Router);
  const canActivate: boolean = !userService.getUserSnapshot();

  return canActivate || router.parseUrl('/championships');
};
